
export default class ClientWS {
    constructor(url,cbNotifyMessage) {
        this.conn = null;
        this.url = url;
        this.timeCheckConnection = 5000;
        this.timerNumber = 0;
        this.cbNotifyMessage = cbNotifyMessage;
        this.reconnect = true;  

        this.TYPE_USER_CONNECT = "user-connect";
        this.NOTIFY_CURRENT_VIEWS = "current-views";
    }
    open() {
        var obj = this;            
        try
        {
            this.conn = new WebSocket(this.url);
            this.conn.onopen = function () {
                //console.log("Connection established! : ", obj.timerNumber);
                //obj.cbNotifyMessage.open();
                this.reconnect = true;
                if(obj.timerNumber != 0)
                {
                    clearInterval(obj.timerNumber);
                    obj.timerNumber = 0;
                }
            };

            this.conn.onmessage = function (e) {
                //console.log("onmessage: ", e.data);
                obj.cbNotifyMessage(e.data);
            };
            this.conn.onclose  = function () {
                //obj.cbNotifyMessage.close();
                //console.log("onclose: ",e, obj.reconnect);
                if(obj.timerNumber == 0 && obj.reconnect == true)
                {
                    obj.timerNumber = setInterval(obj.checkConnection,obj.timeCheckConnection,obj);
                    //console.log("onclose: ",obj.timerNumber, obj.timeCheckConnection);                    
                }
                
            };
            this.conn.onerror  = function (e) {
                console.log("onerror: ",e);
            };
        }
        catch(ex)
        {
            console.error("open->catch",ex);
            if(obj.timerNumber == 0)
            {
                this.timerNumber = setInterval(obj.checkConnection,obj.timeCheckConnection,obj);                
            }
        }  
        
    }
    isConnect() {
        if(this.conn ==  null) return false;
        if(this.conn.readyState == WebSocket.OPEN) return true;
        return false;
    }
    send(obj) {
        if(this.isConnect())
        {
            this.conn.send(JSON.stringify(obj));
        }
    }
    checkConnection(obj) {
        try
        {
            //console.log("checkConnection");
            obj.close();
            obj.open();
        }
        catch(ex)
        {
            console.error("checkconnection",ex);
        }            
    }
    close() {
        try
        {
            this.reconnect = false;
            if(this.conn != null)
            {
                this.conn.close();
                this.conn = null;
            }                               
        }
        catch(ex)
        {
            console.error("checkconnection",ex);
        }      
    }   
}